import {SEARCH_CALENDER_LIST } from "../../utils/constants"


const initialState = [];

function searchCalender(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SEARCH_CALENDER_LIST:
            return [...state, payload];
        default:
            return state;
    }
};

export default searchCalender;